import { render } from "./theme10.vue?vue&type=template&id=f16869c4&scoped=true"
import script from "./theme10.vue?vue&type=script&lang=js"
export * from "./theme10.vue?vue&type=script&lang=js"

import "./theme10.vue?vue&type=style&index=0&id=f16869c4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f16869c4"

export default script